export default __webpack_public_path__ + "static/media/lettuce.efe2354a.png";